/* Výpis oblíbených děl (2026-09-19).

   Data leží v prohlížeči návštěvníka pod klíčem `galelie-oblibene`; zapisuje
   je srdce v prohlížečce děl (assets/listovani.js). Server o nich neví nic,
   proto se celá stránka skládá tady.

   Uložený záznam nese i název, cenu a obrázek, takže se nic nedotahuje
   z katalogu — stránka je hotová okamžitě a funguje i offline.

   Každý přístup k úložišti je v try/catch: v anonymním okně nebo při
   zakázaných datech webu umí vyhodit výjimku i samotné čtení. */
(function () {
  'use strict';

  // Ukládání drží assets/oblibene-sklad.js (načítá se dřív). Bez něj by
  // stránka neměla co vypsat, takže se rovnou vzdá.
  var sklad = window.GalelieOblibene;

  var korenY = document.querySelector('[data-oblibene]');
  if (!korenY || !sklad) return;

  var mrizka = korenY.querySelector('[data-oblibene-mrizka]');
  var prazdno = korenY.querySelector('[data-oblibene-prazdno]');
  var poznamka = korenY.querySelector('[data-oblibene-pozn]');
  var popisekOdebrat = korenY.getAttribute('data-odebrat') || 'Odebrat';

  function nacti() {
    return sklad.nacti();
  }

  function uloz(pole) {
    sklad.uloz(pole);
  }

  // Adresa z uloženého záznamu má šířku podle dlaždice, ze které se ukládalo.
  // Tady je potřeba větší, jinak by byl obrázek rozmazaný.
  function sirka(url, px) {
    if (!url) return '';
    var plna = url.indexOf('//') === 0 ? 'https:' + url : url;
    if (/[?&]width=\d+/.test(plna)) return plna.replace(/([?&])width=\d+/, '$1width=' + px);
    return plna + (plna.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
  }

  function karta(d) {
    var polozka = document.createElement('div');
    polozka.className = 'oblibene-karta';

    var odkaz = document.createElement('a');
    odkaz.className = 'oblibene-odkaz-dilo';
    odkaz.href = d.url || '#';

    if (d.obrazek) {
      var obr = document.createElement('img');
      obr.src = sirka(d.obrazek, 600);
      obr.srcset = sirka(d.obrazek, 400) + ' 400w, ' + sirka(d.obrazek, 600) + ' 600w, ' + sirka(d.obrazek, 900) + ' 900w';
      obr.sizes = '(max-width: 820px) 46vw, 300px';
      obr.alt = d.nazev || '';
      obr.loading = 'lazy';
      obr.decoding = 'async';
      odkaz.appendChild(obr);
    }

    var popis = document.createElement('div');
    popis.className = 'oblibene-popis';
    var nazev = document.createElement('b');
    nazev.textContent = d.nazev || '';
    var cena = document.createElement('span');
    cena.textContent = d.cena || '';
    popis.appendChild(nazev);
    popis.appendChild(cena);
    odkaz.appendChild(popis);

    var pryc = document.createElement('button');
    pryc.type = 'button';
    pryc.className = 'oblibene-pryc';
    pryc.setAttribute('aria-label', popisekOdebrat);
    pryc.innerHTML = '&times;';
    pryc.addEventListener('click', function () {
      var pole = nacti();
      for (var i = 0; i < pole.length; i++) {
        if (pole[i].handle === d.handle) {
          pole.splice(i, 1);
          break;
        }
      }
      uloz(pole);
      vykresli();
    });

    polozka.appendChild(odkaz);
    polozka.appendChild(pryc);
    return polozka;
  }

  function vykresli() {
    var pole = nacti();
    // Naposledy uložené nahoře — to je to, co má člověk v hlavě.
    pole.sort(function (a, b) { return (b.kdy || 0) - (a.kdy || 0); });

    mrizka.innerHTML = '';
    pole.forEach(function (d) { mrizka.appendChild(karta(d)); });

    var mame = pole.length > 0;
    mrizka.hidden = !mame;
    poznamka.hidden = !mame;
    prazdno.hidden = mame;
  }

  vykresli();

  // Když si někdo otevře stránku ve dvou záložkách a v jedné odebere.
  window.addEventListener('storage', vykresli);
  window.addEventListener('galelie-oblibene-zmena', vykresli);
})();
